export enum WSConnectionStatus {
  WS_CONNECTING = 'WS_CONNECTING',
  WS_DISCONNECTING = 'WS_DISCONNECTING',
  WS_CONNECTED = 'WS_CONNECTED',
  WS_DISCONNECTED = 'WS_DISCONNECTED'
}
